export const countArticleRatings = {
  analysisType: 'count',
  eventCollection: 'kb.article.rated',
}
